// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"AttendeesPage_pageWrapper__1JGC8"};